
import Splide from '@splidejs/splide'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    components: { Icon },
    props: {
        suggestion: {
            required: true,
            type: Object
        },
        id: {
            required: true,
            type: String
        },
        isSlider: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            splide: null
        }
    },
    mounted () {
        this.init()
    },
    updated () {
        this.init()
    },
    beforeDestroy () {
        this.destroy()
    },
    methods: {
        destroy () {
            if (this.splide) {
                this.splide.destroy()
            }
        },
        init () {
            this.destroy()
            if (!this.isSlider) {
                return
            }
            const options = {
                arrows: true,
                focus: 0,
                autoWidth: true,
                pagination: true,
                omitEnd: true,
                type: 'slide',
                direction: this.$helpers.getDir()
            }
            this.splide = new Splide(`#${this.id}`, options)
            this.splide.mount({})
        }
    }
}

